import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import { useParams } from 'react-router-dom';
import { toast } from "sonner";
import { API_URL, BASE_URL } from './Config';
import config from "./common/Config";
import {
  Box,
  Paper,
  Typography,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Link as MuiLink,
  Chip,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
} from "@mui/material";
import { Iconify } from "./Minimal/src/components/iconify/iconify";
import "./common/commonStyles.css";

const CloseTripSummary = (props) => {
	const { tripId } = useParams();
	const [tripOrder, setTripOrder] = useState([]);
	const [deliveredOrders, setDeliveredOrders] = useState([]);
	const [tripNumber, setTripNumber] = useState([]);
	const [driverName, setDriverName] = useState([]);
	const [vehicle, setVehicle] = useState([]);
	const [date, setDate] = useState([]);
	const [undeliveredOrders, setUndeliveredOrders] = useState([]);
	const [cashCollection, setCashCollection] = useState([]);
	const [totalCashCollection, setTotalCashCollection] = useState(0);
	const [chequeCollection, setChequeCollection] = useState([]);
	const [totalChequeCollection, setTotalChequeCollection] = useState(0);
	const [partialNotDeliveredBox, setPartialNotDeliveredBox] = useState([]);
	const [partialNotDeliveredPiece, setPartialNotDeliveredPiece] = useState([]);
	const [undeliveredProductsList, setUndeliveredProductsList] = useState([]);
	const [totalUndeliveredBox, setTotalUndeliveredBox] = useState(0);
	const [totalUndeliveredPcs, setTotalUndeliveredPcs] = useState(0);
	const [returnProductsList, setReturnProductsList] = useState([]);
	const [totalReturnBox, setTotalReturnBox] = useState(0);
	const [totalReturnPcs, setTotalReturnPcs] = useState(0);
	const [totalProductsBox, setTotalProductsBox] = useState([]);
	const [totalProductsPiece, setTotalProductsPiece] = useState([]);
	const [deliveredProductsBox, setDeliveredProductsBox] = useState([]);
	const [deliveredProductsPices, setDeliveredProductsPices] = useState([]);
	const [undeliveredProductsBox, setUndeliveredProductsBox] = useState([]);
	const [undeliveredProductsPices, setUndeliveredProductsPices] = useState([]);
	const [deliveredAmt, setDeliveredAmt] = useState(0);
	const [undeliveredAmt, setUndeliveredAmt] = useState(0);
	const deliveredAmtValue = parseFloat(deliveredAmt);
	const undeliveredAmtValue = parseFloat(undeliveredAmt);
	const totalAmt = parseFloat(deliveredAmtValue + undeliveredAmtValue).toFixed(2);
	const [deliveredOrderDetails, setDeliveredOrderDetails] = useState([]);
	const [undeliveredOrderDetails, setUndeliveredOrderDetails] = useState([]);
	const [partialUndelivered, setPartialUndelivered] = useState([]);
	const [returnDetails, setReturnDetails] = useState([]);
	const [totalManifest, setTotalManifest] = useState([]);
	const accessToken = localStorage.getItem('accessToken');
	const token = localStorage.getItem('token');
	const company_tax_type = localStorage.getItem('company_tax_type');
	const currencySymbol = localStorage.getItem('currencySymbol');
	const [showOrdersDeliveredDialog, setShowOrdersDeliveredDialog] = useState(false);
	const [showOrdersUndeliveredDialog, setShowOrdersUndeliveredDialog] = useState(false);
	const [showPartialUndeliveredDialog, setShowPartialUndeliveredDialog] = useState(false);
	const [showUndeliveredProductsDialog, setShowUndeliveredProductsDialog] = useState(false);
	const [showReturnDetailsDialog, setShowReturnDetailsDialog] = useState(false);
	const [showProofDeliveryDialog, setShowProofDeliveryDialog] = useState(false);
	const [proofDeliveryImage, setProofDeliveryImage] = useState("");
	const [returnMenuAnchor, setReturnMenuAnchor] = useState({ el: null, returnId: null });
	const [loading, setLoading] = useState(false);

	const handleReturnMenuOpen = (event, returnId) => {
		event.stopPropagation();
		setReturnMenuAnchor({ el: event.currentTarget, returnId });
	};

	const handleReturnMenuClose = () => {
		setReturnMenuAnchor({ el: null, returnId: null });
	};

	const handleReturnMenuAction = async (action, returnId) => {
		handleReturnMenuClose();
		const isAcceptReturn = action === 'accept';
		const urlRejectLink = `${config.API_URL}/add_reject_return`;
		const urlAcceptLink = `${config.API_URL}/add_accept_return`;
		
		if (isAcceptReturn) {
			const confirmed = window.confirm("Are you sure you want to create the Credit Note?");
			if (confirmed) {
				await sendApiRequest(urlAcceptLink, returnId, "yes");
			} else {
				await sendApiRequest(urlAcceptLink, returnId, "no");
			}
		} else {
			const confirmed = window.confirm("Are you sure you want reject order?");
			if (confirmed) {
				await sendApiRequest(urlRejectLink, returnId);
			}
		}
	};

	const sendApiRequest = async (url, id, allocation = null) => {
		const formData = new FormData();
		formData.append("id", id);
		if (allocation) {
			formData.append("allocation", allocation);
		}

		try {
			const response = await fetch(url, {
				method: "POST",
				headers: {
					authorization: `Bearer ${accessToken}`,
				},
				body: formData,
			});

			const data = await response.json();
			if (data) {
				toast.success("Operation completed successfully.");
				setTimeout(() => {
					window.location.href = `${config.BASE_URL}/closed_trip_summary/${tripId}`;
				}, 500);
				} else {
				toast.error(data.message || "Operation failed");
				}
		} catch (error) {
			console.error("API request failed:", error);
			toast.error("Operation failed");
			}
	};

	const fetchData = async () => {
		setLoading(true);
		const formData = new FormData();
		formData.append('tripId', tripId);
		const apiUrl = `${API_URL}/get-trip-summary`;
		try {
			const response = await fetch(apiUrl, {
				method: 'POST',
				headers: {
					authorization: `Bearer ${token}`,
				},
				body: formData,
			});

			if (!response.ok) {
				throw new Error('Failed to fetch new sales data');
			}

			const data = await response.json();
			const tripData = data.data;

			setTripOrder(tripData.trip_order_details);
			setDeliveredOrders(tripData.deliverySummary.delivered_orders);
			setTripNumber(tripData.trip_number);
			setDriverName(tripData.driver);
			setVehicle(tripData.vehicle);
			setDate(tripData.date);
			setUndeliveredOrders(tripData.deliverySummary.undelivered_orders);
			setCashCollection(tripData.payment_collection.cash_collection_details);
			setChequeCollection(tripData.payment_collection.cheque_collection_details);
			setPartialNotDeliveredBox(tripData.partial_not_delivered_box);
			setPartialNotDeliveredPiece(tripData.partial_not_delivered_piece);
			setUndeliveredProductsList(tripData.undelivered_products_list);
			setReturnProductsList(tripData.return_products_list);
			setTotalProductsBox(tripData.total_products_box);
			setTotalProductsPiece(tripData.total_products_piece);
			setDeliveredProductsBox(tripData.delivered_products_box);
			setDeliveredProductsPices(tripData.delivered_products_piece);
			setUndeliveredProductsBox(tripData.undelivered_products_box);
			setUndeliveredProductsPices(tripData.undelivered_products_piece);
			setDeliveredAmt(parseFloat(tripData.deliverySummary.delivered_amt).toFixed(2));
			setUndeliveredAmt(parseFloat(tripData.deliverySummary.undelivered_amt).toFixed(2));
			setDeliveredOrderDetails(tripData.deliverySummary.delivered_order_details);
			setUndeliveredOrderDetails(tripData.deliverySummary.undelivered_order_details);
			setPartialUndelivered(tripData.partial_undelivered);
			setReturnDetails(tripData.return_details);
			setTotalManifest(tripData.total_manifest);
		} catch (error) {
			console.error('Error fetching new sales data:', error);
			toast.error("Failed to load trip summary");
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		const calculateTotalPrice = () => {
			const total = cashCollection.reduce((acc, product) => {
				const price = parseFloat(product.cashCollected);
				if (!isNaN(price)) {
					return acc + price;
				}
				return acc;
			}, 0);
			setTotalCashCollection(total.toFixed(2));
		};
		calculateTotalPrice();

		const calculateTotalCheque = () => {
			const total = chequeCollection.reduce((acc, product) => {
				const price = parseFloat(product.chequeAmount);
				if (!isNaN(price)) {
					return acc + price;
				}
				return acc;
			}, 0);
			setTotalChequeCollection(total.toFixed(2));
		};
		calculateTotalCheque();

		let pieces = 0;
		let boxes = 0;
		const calculateUndeliveredProducts = () => {
			const total = undeliveredProductsList.reduce((acc, product) => {
				const pdtQty = parseFloat(product.qty);
				if (!isNaN(pdtQty)) {
					if (product.qtyType === 'piece') {
						pieces += pdtQty;
					} else if (product.qtyType === 'box') {
						boxes += pdtQty;
					}
				}
			}, 0);
			setTotalUndeliveredBox(boxes);
			setTotalUndeliveredPcs(pieces);
		};
		calculateUndeliveredProducts();

		let returnPcs = 0;
		let returnBox = 0;
		const calculateReturnProducts = () => {
			const total = returnProductsList.reduce((acc, product) => {
				const pdtQty = parseFloat(product.qty);
				if (!isNaN(pdtQty)) {
					if (product.qtyType === 'piece') {
						returnPcs += pdtQty;
					} else if (product.qtyType === 'box') {
						returnBox += pdtQty;
					}
				}
			}, 0);
			setTotalReturnBox(returnBox);
			setTotalReturnPcs(returnPcs);
		};
		calculateReturnProducts();
	}, [cashCollection, chequeCollection, undeliveredProductsList, returnProductsList]);

	useEffect(() => {
		if (accessToken === null) {
			window.location.href = `${config.BASE_URL}/login`;
			return;
		}
		fetchData();
	}, []);

	useEffect(() => {
		const handleDownloadProof = async (e) => {
				e.preventDefault();
			const imageUrl = proofDeliveryImage;
				const apiUrl = `${config.API_URL}/download-image?url=${encodeURIComponent(imageUrl)}`;

			try {
				const response = await fetch(apiUrl);
						if (!response.ok) {
							throw new Error("Download failed");
						}
				const blob = await response.blob();
						const blobUrl = URL.createObjectURL(blob);
						const link = document.createElement("a");
						link.href = blobUrl;
						link.download = "proof_of_delivery.jpg";
						document.body.appendChild(link);
						link.click();
						document.body.removeChild(link);
						URL.revokeObjectURL(blobUrl);
			} catch (error) {
						console.error("Error downloading image:", error);
				toast.error("Failed to download image. Please try again.");
			}
		};

		const downloadBtn = document.getElementById("downloadProofBtn");
		if (downloadBtn) {
			downloadBtn.addEventListener("click", handleDownloadProof);
			return () => {
				downloadBtn.removeEventListener("click", handleDownloadProof);
			};
		}
	}, [proofDeliveryImage]);

	const handleProofDeliveryClick = (imageUrl) => {
		if (imageUrl) {
			setProofDeliveryImage(imageUrl);
			setShowProofDeliveryDialog(true);
		} else {
			toast.info("No proof of delivery image available");
		}
	};

	return (
		<>
			<Box sx={{ backgroundColor: "#f5f7fa", minHeight: "calc(100vh - 44px)", p:1.5 }}>
					<Paper
						elevation={0}
						sx={{
							borderRadius: 2,
							border: "1px solid rgba(145, 158, 171, 0.16)",
							overflow: "hidden",
							backgroundColor: "#fff",
						
						}}
					>
						<Box sx={{ px: 2, py:1, borderBottom: "1px solid rgba(145, 158, 171, 0.16)" }}>
							<Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 2 }}>
								<Typography sx={{ fontWeight: 500, color: "#212b36", fontSize: "1.125rem" }}>
									Complete Trip Summary - {tripNumber}
								</Typography>
								<Box sx={{ display: "flex", alignItems: "center", gap: 2, flexWrap: "wrap" }}>
									<Typography variant="body2" sx={{ color: "#637381", fontSize: "0.875rem" }}>
										<span style={{ fontWeight: 500, color: "#212b36" }}>Date - </span> {date}
									</Typography>
									<Typography variant="body2" sx={{ color: "#637381", fontSize: "0.875rem" }}>
										<span style={{ fontWeight: 500, color: "#212b36" }}>Driver - </span> {driverName}
									</Typography>
									<Typography variant="body2" sx={{ color: "#637381", fontSize: "0.875rem" }}>
										<span style={{ fontWeight: 500, color: "#212b36" }}>Vehicle - </span> {vehicle}
									</Typography>
									<Button
										variant="contained"
										className="button-variant-contained"
										href={`/closed_trip_summary/${tripId}`}
										target="_blank"
										rel="noopener noreferrer"
									
									>
										Summary Report
									</Button>
								</Box>
							</Box>
						</Box>
						<Box sx={{ p: 2 }}>
							<Grid container spacing={2}>
								<Grid item xs={12} sm={6} lg={3}>
									<Paper
										elevation={0}
										sx={{
											border: "1px solid rgba(145, 158, 171, 0.16)",
											borderRadius: 1,
											overflow: "hidden",
										}}
									>
										<Table size="small" className="table-cell-border">
											<TableBody>
												<TableRow>
													<TableCell sx={{ fontWeight: 500, fontSize: "0.775rem", color: "#212b36", borderBottom: "1px solid rgba(145, 158, 171, 0.16)" }}>
														Orders Delivered
													</TableCell>
													<TableCell sx={{ fontSize: "0.875rem", color: "#212b36", borderBottom: "1px solid rgba(145, 158, 171, 0.16)" }}>
														<MuiLink
															component="button"
															onClick={() => setShowOrdersDeliveredDialog(true)}
															sx={{
																color: "inherit",
																textDecoration: "underline",
																textDecorationColor: "currentColor",
																textUnderlineOffset: "2px",
																cursor: "pointer",
																"&:hover": {
																	textDecoration: "underline",
																},
															}}
														>
															{deliveredOrders}
														</MuiLink>
													</TableCell>
												</TableRow>
												<TableRow>
													<TableCell sx={{ fontWeight: 500, fontSize: "0.775rem", color: "#212b36", borderBottom: "1px solid rgba(145, 158, 171, 0.16)" }}>
														Orders Undelivered
													</TableCell>
													<TableCell sx={{ fontSize: "0.775rem", color: "#212b36", borderBottom: "1px solid rgba(145, 158, 171, 0.16)" }}>
														<MuiLink
															component="button"
															onClick={() => setShowOrdersUndeliveredDialog(true)}
															sx={{
																color: "inherit",
																textDecoration: "underline",
																textDecorationColor: "currentColor",
																textUnderlineOffset: "2px",
																cursor: "pointer",
																"&:hover": {
																	textDecoration: "underline",
																},
															}}
														>
															{undeliveredOrders}
														</MuiLink>
													</TableCell>
												</TableRow>
												<TableRow>
													<TableCell sx={{ fontWeight: 500, fontSize: "0.775rem", color: "#212b36", borderBottom: "1px solid rgba(145, 158, 171, 0.16)" }}>
														Cash Collected
													</TableCell>
													<TableCell sx={{ fontSize: "0.775rem", color: "#212b36", borderBottom: "1px solid rgba(145, 158, 171, 0.16)" }}>
														{currencySymbol} {totalCashCollection}
													</TableCell>
												</TableRow>
												<TableRow>
													<TableCell sx={{ fontWeight: 500, fontSize: "0.775rem", color: "#212b36" }}>
														Cheque (0)
													</TableCell>
													<TableCell sx={{ fontSize: "0.775rem", color: "#212b36" }}>
														{currencySymbol} {totalChequeCollection}
													</TableCell>
												</TableRow>
											</TableBody>
										</Table>
									</Paper>
								</Grid>
								<Grid item xs={12} sm={6} lg={3}>
									<Paper
										elevation={0}
										sx={{
											border: "1px solid rgba(145, 158, 171, 0.16)",
											borderRadius: 1,
											overflow: "hidden",
										}}
									>
										<Table size="small" className="table-cell-border">
											<TableHead>
												<TableRow className="table-cell-header">
													<TableCell sx={{ fontWeight: 600, fontSize: "0.75rem", color: "#212b36", borderBottom: "1px solid rgba(145, 158, 171, 0.16)", width: "70%" }}>
														Return Goods
													</TableCell>
													<TableCell sx={{ fontWeight: 600, fontSize: "0.75rem", color: "#212b36", borderBottom: "1px solid rgba(145, 158, 171, 0.16)", width: "30%" }}>
														Box
													</TableCell>
													<TableCell sx={{ fontWeight: 600, fontSize: "0.75rem", color: "#212b36", borderBottom: "1px solid rgba(145, 158, 171, 0.16)", width: "30%" }}>
														Pcs
													</TableCell>
												</TableRow>
											</TableHead>
											<TableBody>
												<TableRow>
													<TableCell sx={{ fontSize: "0.775rem", color: "#212b36", borderBottom: "1px solid rgba(145, 158, 171, 0.16)" }}>
														<MuiLink
															component="button"
															onClick={() => setShowPartialUndeliveredDialog(true)}
															sx={{
																color: "inherit",
																textDecoration: "underline",
																textDecorationColor: "currentColor",
																textUnderlineOffset: "2px",
																cursor: "pointer",
																"&:hover": {
																	textDecoration: "underline",
																},
															}}
														>
															Partial Undeliv.
														</MuiLink>
													</TableCell>
													<TableCell sx={{ fontSize: "0.775rem", color: "#212b36", borderBottom: "1px solid rgba(145, 158, 171, 0.16)" }}>
														{partialNotDeliveredBox}
													</TableCell>
													<TableCell sx={{ fontSize: "0.775rem", color: "#212b36", borderBottom: "1px solid rgba(145, 158, 171, 0.16)" }}>
														{partialNotDeliveredPiece}
													</TableCell>
												</TableRow>
												<TableRow>
													<TableCell sx={{ fontSize: "0.775rem", color: "#212b36", borderBottom: "1px solid rgba(145, 158, 171, 0.16)" }}>
														<MuiLink
															component="button"
															onClick={() => setShowUndeliveredProductsDialog(true)}
															sx={{
																color: "inherit",
																textDecoration: "underline",
																textDecorationColor: "currentColor",
																textUnderlineOffset: "2px",
																cursor: "pointer",
																"&:hover": {
																	textDecoration: "underline",
																},
															}}
														>
															Undelivered
														</MuiLink>
													</TableCell>
													<TableCell sx={{ fontSize: "0.775rem", color: "#212b36", borderBottom: "1px solid rgba(145, 158, 171, 0.16)" }}>
														{totalUndeliveredBox}
													</TableCell>
													<TableCell sx={{ fontSize: "0.775rem", color: "#212b36", borderBottom: "1px solid rgba(145, 158, 171, 0.16)" }}>
														{totalUndeliveredPcs}
													</TableCell>
												</TableRow>
												<TableRow>
													<TableCell sx={{ fontSize: "0.775rem", color: "#212b36" }}>
														<MuiLink
															component="button"
															onClick={() => setShowReturnDetailsDialog(true)}
															sx={{
																color: "inherit",
																textDecoration: "underline",
																textDecorationColor: "currentColor",
																textUnderlineOffset: "2px",
																cursor: "pointer",
																"&:hover": {
																	textDecoration: "underline",
																},
															}}
														>
															Return
														</MuiLink>
													</TableCell>
													<TableCell sx={{ fontSize: "0.775rem", color: "#212b36" }}>
														{totalReturnBox}
													</TableCell>
													<TableCell sx={{ fontSize: "0.775rem", color: "#212b36" }}>
														{totalReturnPcs}
													</TableCell>
												</TableRow>
											</TableBody>
										</Table>
									</Paper>
								</Grid>
								<Grid item xs={12} sm={6} lg={3}>
									<Paper
										elevation={0}
										sx={{
											border: "1px solid rgba(145, 158, 171, 0.16)",
											borderRadius: 1,
											overflow: "hidden",
										}}
									>
										<Table size="small" className="table-cell-border">
											<TableHead>
												<TableRow className="table-cell-header">
													<TableCell sx={{ fontWeight: 600, fontSize: "0.75rem", color: "#212b36", borderBottom: "1px solid rgba(145, 158, 171, 0.16)", width: "70%" }}>
														&nbsp;
													</TableCell>
													<TableCell sx={{ fontWeight: 600, fontSize: "0.75rem", color: "#212b36", borderBottom: "1px solid rgba(145, 158, 171, 0.16)", width: "30%" }}>
														Box
													</TableCell>
													<TableCell sx={{ fontWeight: 600, fontSize: "0.75rem", color: "#212b36", borderBottom: "1px solid rgba(145, 158, 171, 0.16)", width: "30%" }}>
														Pcs
													</TableCell>
												</TableRow>
											</TableHead>
											<TableBody>
												<TableRow>
													<TableCell sx={{ fontWeight: 500, fontSize: "0.775rem", color: "#212b36", borderBottom: "1px solid rgba(145, 158, 171, 0.16)" }}>
														Total Products
													</TableCell>
													<TableCell sx={{ fontSize: "0.775rem", color: "#212b36", borderBottom: "1px solid rgba(145, 158, 171, 0.16)" }}>
														{totalProductsBox}
													</TableCell>
													<TableCell sx={{ fontSize: "0.775rem", color: "#212b36", borderBottom: "1px solid rgba(145, 158, 171, 0.16)" }}>
														{totalProductsPiece}
													</TableCell>
												</TableRow>
												<TableRow>
													<TableCell sx={{ fontWeight: 500, fontSize: "0.775rem", color: "#212b36", borderBottom: "1px solid rgba(145, 158, 171, 0.16)" }}>
														Delivered
													</TableCell>
													<TableCell sx={{ fontSize: "0.775rem", color: "#212b36", borderBottom: "1px solid rgba(145, 158, 171, 0.16)" }}>
														{deliveredProductsBox}
													</TableCell>
													<TableCell sx={{ fontSize: "0.775rem", color: "#212b36", borderBottom: "1px solid rgba(145, 158, 171, 0.16)" }}>
														{deliveredProductsPices}
													</TableCell>
												</TableRow>
												<TableRow>
													<TableCell sx={{ fontWeight: 500, fontSize: "0.775rem", color: "#212b36" }}>
														Undelivered
													</TableCell>
													<TableCell sx={{ fontSize: "0.775rem", color: "#212b36" }}>
														{undeliveredProductsBox}
													</TableCell>
													<TableCell sx={{ fontSize: "0.775rem", color: "#212b36" }}>
														{undeliveredProductsPices}
													</TableCell>
												</TableRow>
											</TableBody>
										</Table>
									</Paper>
								</Grid>
								<Grid item xs={12} sm={6} lg={3}>
									<Paper
										elevation={0}
										sx={{
											border: "1px solid rgba(145, 158, 171, 0.16)",
											borderRadius: 1,
											overflow: "hidden",
										}}
									>
										<Table size="small" className="table-cell-border">
											<TableBody>
												<TableRow>
													<TableCell sx={{ fontWeight: 500, fontSize: "0.775rem", color: "#212b36", borderBottom: "1px solid rgba(145, 158, 171, 0.16)" }}>
														Delivered AMT
													</TableCell>
													<TableCell sx={{ fontSize: "0.775rem", color: "#212b36", borderBottom: "1px solid rgba(145, 158, 171, 0.16)" }}>
														{currencySymbol} {deliveredAmt}
													</TableCell>
												</TableRow>
												<TableRow>
													<TableCell sx={{ fontWeight: 500, fontSize: "0.775rem", color: "#212b36", borderBottom: "1px solid rgba(145, 158, 171, 0.16)" }}>
														Undeliverd AMT
													</TableCell>
													<TableCell sx={{ fontSize: "0.775rem", color: "#212b36", borderBottom: "1px solid rgba(145, 158, 171, 0.16)" }}>
														{currencySymbol} {undeliveredAmt}
													</TableCell>
												</TableRow>
												<TableRow>
													<TableCell sx={{ fontSize: "0.775rem", color: "#212b36", borderBottom: "1px solid rgba(145, 158, 171, 0.16)" }}>
														&nbsp;
													</TableCell>
													<TableCell sx={{ fontSize: "0.775rem", color: "#212b36", borderBottom: "1px solid rgba(145, 158, 171, 0.16)" }}>
														&nbsp;
													</TableCell>
												</TableRow>
												<TableRow>
													<TableCell sx={{ fontWeight: 600, fontSize: "0.8rem", color: "#212b36" }}>
														Total
													</TableCell>
													<TableCell sx={{ fontWeight: 600, fontSize: "0.8rem", color: "#212b36" }}>
														{currencySymbol} {totalAmt}
													</TableCell>
												</TableRow>
											</TableBody>
										</Table>
									</Paper>
								</Grid>
							</Grid>
						</Box>
					</Paper>

					<Box sx={{ mt: 3 }}>
						<Paper
							elevation={0}
							sx={{
								borderRadius: 2,
								border: "1px solid rgba(145, 158, 171, 0.16)",
								overflow: "hidden",
								backgroundColor: "#fff"
							}}
						>
							<Box sx={{ px: 2, py:1}}>
								<Typography variant="subtitle1" sx={{ fontWeight: 600, color: "#212b36" }}>
									Total Manifests: {totalManifest}
								</Typography>
							</Box>
							<TableContainer sx={{ width: "100%" }}>
								<Table
									size="medium"
									className="table-cell-border"
								>
									<TableHead>
										<TableRow className="table-cell-header">
												{[
													"#",
													"Customers (A/C No)",
													"Manifest No",
													"Order ID",
													"Post code",
													"Route",
													"Status",
													"Action"
											].map((header) => {
												let align = "left";
												if (header === "#" || header === "Order ID" || header === "Post code" || header === "Route" || header === "Status" || header === "Action") {
													align = "center";
												}
												return (
													<TableCell
														key={header}
														align={align}
														sx={{
															fontWeight: 600,
															fontSize: '0.75rem',
															color: '#212b36',
															letterSpacing: 0.5,
															py: 1,
														}}
													>
														{header}
													</TableCell>
												);
											})}
										</TableRow>
									</TableHead>
									<TableBody>
										{loading ? (
											<TableRow>
												<TableCell colSpan={8} align="center" sx={{ py: 4 }}>
													<Typography variant="body2" color="text.secondary">
														Loading...
													</Typography>
												</TableCell>
											</TableRow>
										) : tripOrder.length > 0 ? (
											tripOrder.map((row, index) => (
												<TableRow
													key={row.orderId || index}
													hover
													sx={{
														"&:hover": {
															backgroundColor: "rgba(145, 158, 171, 0.04)"
														},
													
													}}
												>
													<TableCell align="center" sx={{ py: 1, fontSize: "0.75rem", color: "#212b36" }}>
														{index + 1}
													</TableCell>
													<TableCell sx={{ py: 1, fontSize: "0.75rem", color: "#212b36" }}>
														{row.customerName} ({row.customerAccountNo})
													</TableCell>
													<TableCell sx={{ py: 1, fontSize: "0.75rem", color: "#212b36" }}>
														{row.manifestId || ''}
													</TableCell>
													<TableCell align="center" sx={{ py: 1, fontSize: "0.75rem", color: "#212b36" }}>
														<MuiLink
															href={`${BASE_URL}/trip_summary/print/${row.orderId}`}
															target="_blank"
															rel="noopener noreferrer"
															sx={{
																color: "inherit",
																textDecoration: "underline !important",
																textDecorationColor: "currentColor",
																textUnderlineOffset: "2px",
																"&:hover": {
																	textDecoration: "underline !important",
																	textDecorationColor: "currentColor"
																}
															}}
														>
															{row.referenceNo}
														</MuiLink>
													</TableCell>
													<TableCell align="center" sx={{ py: 1, fontSize: "0.75rem", color: "#212b36" }}>
														{row.postCode || ''}
													</TableCell>
													<TableCell align="center" sx={{ py: 1, fontSize: "0.75rem", color: "#212b36" }}>
														{row.route || ''}
													</TableCell>
													<TableCell align="center" sx={{ py: 1, fontSize: "0.75rem", color: "#212b36" }}>
														<Chip
															label={row.sale_status}
															size="small"
														
															sx={{
																fontWeight: 500,
																fontSize: '0.7rem',
																height: 24,
																backgroundColor: "#FFD399",
																color: "#000",
																"&:hover": {
																	backgroundColor: "#FFD399",
																	color: "#000",
																},
															}}
														/>
													</TableCell>
													<TableCell align="center" sx={{ py: 1, fontSize: "0.75rem", color: "#212b36" }}>
														{row.proof_of_delivery ? (
															<IconButton
																size="small"
																onClick={() => handleProofDeliveryClick(row.proof_of_delivery)}
																sx={{
																	color: "#637381",
																	"&:hover": {
																		backgroundColor: "rgba(0, 0, 0, 0.04)"
																	}
																}}
															>
																<Iconify icon="eva:image-fill" width={18} height={18} />
															</IconButton>
														) : null}
													</TableCell>
												</TableRow>
											))
										) : (
											<TableRow>
												<TableCell colSpan={8} align="center" sx={{ py: 4 }}>
													<Typography variant="body2" color="text.secondary">
														No records found.
													</Typography>
												</TableCell>
											</TableRow>
										)}
									</TableBody>
								</Table>
							</TableContainer>
						</Paper>
					</Box>
				</Box>

			<Dialog
				open={showOrdersDeliveredDialog}
				onClose={() => setShowOrdersDeliveredDialog(false)}
				maxWidth="md"
				fullWidth
				PaperProps={{
					sx: {
						borderRadius: 2,
					},
				}}
			>
				<DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
					<Typography className="page-title">
						Orders Delivered
					</Typography>
					<IconButton
						onClick={() => setShowOrdersDeliveredDialog(false)}
						sx={{ color: '#637381' }}
					>
						<Iconify icon="mdi:close" width={24} height={24} />
					</IconButton>
				</DialogTitle>
				<DialogContent dividers>
					<TableContainer sx={{ width: "100%" }}>
						<Table size="medium" className="table-cell-border">
							<TableHead>
								<TableRow className="table-cell-header">
									<TableCell width="10%">#</TableCell>
									<TableCell width="15%">Invoice No</TableCell>
									<TableCell width="20%">Invoice Date</TableCell>
									<TableCell width="40%">Customers (A/C No)</TableCell>
								</TableRow>
							</TableHead>
							<TableBody>
									{deliveredOrderDetails.map((item, index) => (
									<TableRow
										key={index}
										hover
										className="table-cell-style"
									
									>
										<TableCell>{index + 1}</TableCell>
										<TableCell>
											<MuiLink
												href={`${BASE_URL}/trip_summary/print/${item.orderId}`}
												sx={{
													color: "inherit",
													textDecoration: "underline !important",
													textDecorationColor: "currentColor",
													textUnderlineOffset: "2px",
													"&:hover": {
														textDecoration: "underline !important",
														textDecorationColor: "currentColor"
													},
												}}
											>
												{item.referenceNo}
											</MuiLink>
										</TableCell>
										<TableCell>{item.invoice_date}</TableCell>
										<TableCell>
											{item.customerName} ( {item.customerAccountNo} )
										</TableCell>
									</TableRow>
								))}
							</TableBody>
						</Table>
					</TableContainer>
				</DialogContent>
				<DialogActions sx={{ px: 3, pb: 2 }}>
					<Button
						onClick={() => setShowOrdersDeliveredDialog(false)}
						className="button-variant-outlined"
						variant="outlined"
					>
						Close
					</Button>
				</DialogActions>
			</Dialog>

			<Dialog
				open={showOrdersUndeliveredDialog}
				onClose={() => setShowOrdersUndeliveredDialog(false)}
				maxWidth="md"
				fullWidth
				PaperProps={{
					sx: {
						borderRadius: 2,
					},
				}}
			>
				<DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
					<Typography className="page-title" variant="h6" sx={{ fontWeight: 600 }}>
						Orders Undelivered
					</Typography>
					<IconButton
						onClick={() => setShowOrdersUndeliveredDialog(false)}
						sx={{ color: '#637381' }}
					>
						<Iconify icon="mdi:close" width={24} height={24} />
					</IconButton>
				</DialogTitle>
				<DialogContent dividers>
					<TableContainer sx={{ width: "100%" }}>
						<Table
							size="medium"
							className="table-cell-border"
						
						>
							<TableHead>
								<TableRow className="table-cell-header">
									<TableCell width="10%">#</TableCell>
									<TableCell width="15%">Invoice No</TableCell>
									<TableCell width="20%">Invoice Date</TableCell>
									<TableCell width="40%">Customers (A/C No)</TableCell>
								</TableRow>
							</TableHead>
							<TableBody>
									{undeliveredOrderDetails.map((item, index) => (
									<TableRow
										key={index}
										hover
										className="table-cell-style"
									>
										<TableCell>{index + 1}</TableCell>
										<TableCell>{item.referenceNo}</TableCell>
										<TableCell>{item.invoice_date}</TableCell>
										<TableCell>
											{item.customerName} ( {item.customerAccountNo} )
										</TableCell>
									</TableRow>
								))}
							</TableBody>
						</Table>
					</TableContainer>
				</DialogContent>
				<DialogActions sx={{ px: 3, pb: 2 }}>
					<Button
						onClick={() => setShowOrdersUndeliveredDialog(false)}
					    className="button-variant-outlined"
						variant="outlined"
					>
						Close
					</Button>
				</DialogActions>
			</Dialog>

			<Dialog
				open={showPartialUndeliveredDialog}
				onClose={() => setShowPartialUndeliveredDialog(false)}
				maxWidth="xl"
				fullWidth
				PaperProps={{
					sx: {
						borderRadius: 2,
					},
				}}
			>
				<DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
					<Typography className="page-title">
						Partial Undelivered List
					</Typography>
					<IconButton
						onClick={() => setShowPartialUndeliveredDialog(false)}
						sx={{ color: '#637381' }}
					>
						<Iconify icon="mdi:close" width={24} height={24} />
					</IconButton>
				</DialogTitle>
				<DialogContent dividers>
					<TableContainer sx={{ width: "100%" }}>
						<Table
							size="medium"
							className="table-cell-border"
						>
							<TableHead>
								<TableRow className="table-cell-header">
									<TableCell width="10%">#</TableCell>
									<TableCell width="15%">Order Id</TableCell>
									<TableCell width="30%">Description</TableCell>
									<TableCell width="10%">Order Qty</TableCell>
									<TableCell width="10%">Order Type</TableCell>
									<TableCell width="10%" align="right">Unit Price</TableCell>
									<TableCell width="10%" align="right">{company_tax_type}</TableCell>
									<TableCell width="10%" align="right">Total</TableCell>
									<TableCell width="10%">Undeli.Qty</TableCell>
									<TableCell width="10%">Reason</TableCell>
								</TableRow>
							</TableHead>
							<TableBody>
									{partialUndelivered.map((item, index) => {
										const subtotal = parseFloat(item.subtotal);
										const tax = parseFloat(item.tax);
										const total = (subtotal + tax).toFixed(2);

										return (
										<TableRow
											key={index}
											hover
											className="table-cell-style"
											
										>
											<TableCell>{index + 1}</TableCell>
											<TableCell>{item.referenceNo}</TableCell>
											<TableCell>{item.productName} ( {item.productCode} )</TableCell>
											<TableCell>{item.quantity}</TableCell>
											<TableCell>{item.order_type}</TableCell>
											<TableCell align="right">{currencySymbol} {item.unit_price}</TableCell>
											<TableCell align="right">{currencySymbol} {item.tax}</TableCell>
											<TableCell align="right">{currencySymbol} {total}</TableCell>
											<TableCell>{item.not_delivered_qty}</TableCell>
											<TableCell>{item.reason}</TableCell>
										</TableRow>
										);
									})}
							</TableBody>
						</Table>
					</TableContainer>
				</DialogContent>
				<DialogActions sx={{ px: 3, pb: 2 }}>
					<Button
					    variant="outlined"
						onClick={() => setShowPartialUndeliveredDialog(false)}
				        className="button-variant-outlined"
					>
						Close
					</Button>
				</DialogActions>
			</Dialog>

			<Dialog
				open={showUndeliveredProductsDialog}
				onClose={() => setShowUndeliveredProductsDialog(false)}
				maxWidth="lg"
				fullWidth
				PaperProps={{
					sx: {
						borderRadius: 2,
					},
				}}
			>
				<DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
					<Typography className="page-title">
						Undelivered Products
					</Typography>
					<IconButton
						onClick={() => setShowUndeliveredProductsDialog(false)}
						sx={{ color: '#637381' }}
					>
						<Iconify icon="mdi:close" width={24} height={24} />
					</IconButton>
				</DialogTitle>
				<DialogContent dividers>
					<TableContainer sx={{ width: "100%" }}>
						<Table
							size="medium"
							className="table-cell-border"
						>
							<TableHead>
								<TableRow className="table-cell-header">
									<TableCell width="10%">#</TableCell>
									<TableCell width="30%">Description</TableCell>
									<TableCell width="10%">Order Qty</TableCell>
									<TableCell width="10%">Order Type</TableCell>
									<TableCell width="10%" align="right">Unit Price</TableCell>
									<TableCell width="10%" align="right">{company_tax_type}</TableCell>
									<TableCell width="10%" align="right">Total</TableCell>
								</TableRow>
							</TableHead>
							<TableBody>
									{undeliveredProductsList.map((item, index) => {
										const unSubtotal = parseFloat(item.subtotal);
										const unTax = parseFloat(item.item_tax);
										const unTotal = (unSubtotal + unTax).toFixed(2);

										return (
										<TableRow
											key={index}
											hover
											className="table-cell-style"
										>
											<TableCell>{index + 1}</TableCell>
											<TableCell>{item.productName} ( {item.productCode} )</TableCell>
											<TableCell>{item.qty}</TableCell>
											<TableCell>{item.qtyType}</TableCell>
											<TableCell align="right">{currencySymbol} {item.unit_price}</TableCell>
											<TableCell align="right">{currencySymbol} {item.item_tax}</TableCell>
											<TableCell align="right">{currencySymbol} {unTotal}</TableCell>
										</TableRow>
										);
									})}
							</TableBody>
						</Table>
					</TableContainer>
				</DialogContent>
				<DialogActions sx={{ px: 3, pb: 2 }}>
					<Button
					variant="outlined"
						onClick={() => setShowUndeliveredProductsDialog(false)}
				        className="button-variant-outlined"
					>
						Close
					</Button>
				</DialogActions>
			</Dialog>

			<Dialog
				open={showReturnDetailsDialog}
				onClose={() => setShowReturnDetailsDialog(false)}
				maxWidth="lg"
				fullWidth
				PaperProps={{
					sx: {
						borderRadius: 2,
					},
				}}
			>
				<DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
					<Typography className="page-title">
						Return Details
					</Typography>
					<IconButton
						onClick={() => setShowReturnDetailsDialog(false)}
						sx={{ color: '#637381' }}
					>
						<Iconify icon="mdi:close" width={24} height={24} />
					</IconButton>
				</DialogTitle>
				<DialogContent dividers>
					<TableContainer sx={{ width: "100%" }}>
						<Table
							size="medium"
							className="table-cell-border"
						>
							<TableHead>
								<TableRow className="table-cell-header">
									<TableCell width="10%">#</TableCell>
									<TableCell width="10%">Date</TableCell>
									<TableCell width="15%">Return No</TableCell>
									<TableCell width="25%">Customer (Ac/No)</TableCell>
									<TableCell width="10%">Grand Total</TableCell>
									<TableCell width="10%">Total Items</TableCell>
									<TableCell width="10%">Return By</TableCell>
									<TableCell width="10%">Status</TableCell>
									<TableCell width="10%">Actions</TableCell>
								</TableRow>
							</TableHead>
							<TableBody>
									{returnDetails.map((item, index) => {
									let status = "";
									let statusColor = "default";
									if (item.is_accept === "Y") {
										status = "Accept";
										statusColor = "success";
									} else if (item.is_accept === "R") {
										status = "Reject";
										statusColor = "error";
									} else if (item.is_accept === "N") {
										status = "Pending";
										statusColor = "warning";
										}
										const rdTotal = parseFloat(item.grand_total);

										return (
										<TableRow
											key={index}
											hover
											className="table-cell-style"
										>
											<TableCell>{index + 1}</TableCell>
											<TableCell>{item.date}</TableCell>
											<TableCell>{item.reference_no}</TableCell>
											<TableCell>{item.company} ( {item.accound_no} )</TableCell>
											<TableCell>{currencySymbol} {rdTotal}</TableCell>
											<TableCell>{item.total_items}</TableCell>
											<TableCell>{item.first_name} {item.last_name}</TableCell>
											<TableCell>
												<Chip
													label={status}
													color={statusColor}
													size="small"
													sx={{
														fontWeight: 500,
														fontSize: '0.7rem',
														height: 24,
													}}
												/>
											</TableCell>
											<TableCell align="center" sx={{ py: 1, fontSize: "0.75rem", color: "#212b36" }}>
												{status === "Pending" && (
													<>
														<IconButton
															size="small"
															onClick={(e) => handleReturnMenuOpen(e, item.id)}
															sx={{
																color: "#637381",
																"&:hover": {
																	backgroundColor: "rgba(0, 0, 0, 0.04)"
																}
															}}
														>
															<Iconify icon="eva:more-vertical-fill" width={20} height={20} />
														</IconButton>
														<Menu
															anchorEl={returnMenuAnchor.el}
															open={Boolean(returnMenuAnchor.el) && returnMenuAnchor.returnId === item.id}
															onClose={handleReturnMenuClose}
															anchorOrigin={{
																vertical: 'bottom',
																horizontal: 'right',
															}}
															transformOrigin={{
																vertical: 'top',
																horizontal: 'right',
															}}
															PaperProps={{
																sx: {
																	minWidth: 200,
																	borderRadius: 2,
																	boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
																	mt: 1,
																},
															}}
														>
															<MenuItem onClick={() => handleReturnMenuAction('accept', item.id)}>
																<ListItemIcon>
																	<Iconify icon="eva:checkmark-circle-2-fill" width={20} height={20} />
																</ListItemIcon>
																<ListItemText>Accept Return</ListItemText>
															</MenuItem>
															<MenuItem onClick={() => handleReturnMenuAction('reject', item.id)}>
																<ListItemIcon>
																	<Iconify icon="eva:close-circle-fill" width={20} height={20} />
																</ListItemIcon>
																<ListItemText>Reject Return</ListItemText>
															</MenuItem>
														</Menu>
													</>
												)}
											</TableCell>
										</TableRow>
										);
									})}
							</TableBody>
						</Table>
					</TableContainer>
				</DialogContent>
				<DialogActions sx={{ px: 3, pb: 2 }}>
					<Button
						onClick={() => setShowReturnDetailsDialog(false)}
					    variant="outlined"
						className="button-variant-outlined"
					>
						Close
					</Button>
				</DialogActions>
			</Dialog>

			<Dialog
				open={showProofDeliveryDialog}
				onClose={() => {
					setShowProofDeliveryDialog(false);
					setProofDeliveryImage("");
				}}
				maxWidth="md"
				fullWidth
				PaperProps={{
					sx: {
						borderRadius: 2,
					},
				}}
			>
				<DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
					<Typography variant="h6" sx={{ fontWeight: 600 }}>
								Proof of Delivery
					</Typography>
					<Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
						<Button
							id="downloadProofBtn"
							variant="contained"
							size="small"
							sx={{
								textTransform: "none",
								fontWeight: 600,
								minWidth: "auto",
								px: 1.5,
							}}
						>
							<Iconify icon="eva:download-fill" width={18} height={18} sx={{ mr: 0.5 }} />
							Download
						</Button>
						<IconButton
							onClick={() => {
								setShowProofDeliveryDialog(false);
								setProofDeliveryImage("");
							}}
							sx={{ color: '#637381' }}
						>
							<Iconify icon="mdi:close" width={24} height={24} />
						</IconButton>
					</Box>
				</DialogTitle>
				<DialogContent dividers sx={{ textAlign: "center", p: 3 }}>
					<img
						src={proofDeliveryImage}
								alt="Proof of Delivery"
						style={{ maxWidth: "100%", maxHeight: "400px", objectFit: "contain" }}
					/>
				</DialogContent>
			</Dialog>

		
		</>
	);
};

export default CloseTripSummary;
